
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ConvertEverythingSection } from "@/sections/ConvertEverythingSection";
import { TryBeforeYouBuySection } from "@/sections/TryBeforeYouBuySection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";
import { PricingSection } from "@/sections/PricingSection";

const FigmaToSketch = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/FigmaToSketch"
        ogImage="/images/figma2sketch-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FigmaToSketch:title")}
        subtitle={t("page/FigmaToSketch:subtitle")}
        magicianLogoFile="sketch"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConvertEverythingSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ConvertEverythingSection
        images={[
          {
            src:
              "/svgs/convert-everything/symbols-components-figma-to-sketch.svg",
            alt: "symbols/components",
          },
          {
            src:
              "/svgs/convert-everything/prototyping-transitions-figma-to-sketch.svg",
            alt: "prototyping/transitions",
          },
          {
            src: "/svgs/convert-everything/text-and-colors-sketch.svg",
            alt: "text-and-colors",
          },
        ]}
      />

      <TryBeforeYouBuySection
        title={t("page/FigmaToSketch:section/tryBeforeBuy.title")}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "BOX",
            text: t(
              "page/FigmaToSketch:section/tryBeforeBuy.elements.firstElementText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "SHIELD",
            text: t(
              "page/FigmaToSketch:section/tryBeforeBuy.elements.secondElementText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "LOCK",
            text: t(
              "page/FigmaToSketch:section/tryBeforeBuy.elements.thirdElementText",
            ),
          },
        ]}
        cta={{
          title: t("page/FigmaToSketch:section/tryBeforeBuy.actionLabel"),
        }}
      />
      <VideoSection
        title={t("page/FigmaToSketch:section/videoSection.title")}
        subtitle={t("page/FigmaToSketch:section/videoSection.subtitle")}
        media={{
          type: "VIDEO",
          title: "Upload demo",
          src: "/video/figma-to-sketch-demo.mp4",
        }}
      />

      <PricingSection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "FIGMA",
            image: "/images/figma-preview.jpg",
            title: "Figma Demo Preview",
          },
          to: {
            iconType: "SKETCH",
            image: "/images/sketch-preview.jpg",
            title: "Sketch Demo Preview",
          },
        }}
      />
      <SelectFormatSection title={t("section/selectFormat:title")} />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default FigmaToSketch;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/figma-to-sketch',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  